import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './header.scss';
import timeService from '../../services/TimeService';
import timeRemainingSelector from '../../selectors/header/TimeRemainingSelector';

const TimeRemainingPure = (props) => {
    const {
        lastMinute,
        pauseTime,
        shouldAlertTimeToSR,
        srOnlyTimeRemainingCaption,
        timeRemaining,
        timeRemainingCaption,
        useAlertRole,
    } = props;

    useEffect(() => {
        // To avoid waiting for the next scheduled heartbeat in order to fetch a valid remaining-time.
        // Use-case: From Test_Overview to actual Test contents.
        if (timeRemaining === -1) {
            timeService.fetchTimeRemaining(true, true);
        }
    }, []);

    const classList = [styles.time];
    if (lastMinute) {
        classList.push(styles.lastMinute);
    }

    return (
        <div className={classList.join(' ')}>
            <span className={styles.timePart} id="timeRemainingPart">
                { timeRemainingCaption }
            </span>

            { pauseTime && <i className={`${styles.pauseIcon} fa fa-pause-circle-o`} aria-hidden="true" /> }

            { shouldAlertTimeToSR &&
                <span className="sr-only" role={useAlertRole ? 'alert' : 'status'}>
                    { srOnlyTimeRemainingCaption }
                </span>
            }
        </div>
    );
};

TimeRemainingPure.propTypes = {
    lastMinute: PropTypes.bool.isRequired,
    pauseTime: PropTypes.number,
    shouldAlertTimeToSR: PropTypes.bool.isRequired,
    srOnlyTimeRemainingCaption: PropTypes.string,
    timeRemaining: PropTypes.number,
    timeRemainingCaption: PropTypes.string,
    useAlertRole: PropTypes.bool.isRequired,
};

const TimeRemaining = props => (
    <TimeRemainingPure {...props} {...timeRemainingSelector.selectProps(props)} />
);

export default TimeRemaining;
